const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fda23f",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 14.043 13.565 C 13.419 13.845 12.728 14 12 14 C 11.274 14 10.584 13.845 9.961 13.567 L 5.879 15.422 C 5.344 15.666 5 16.2 5 16.788 L 5 17.5 C 5 18.328 5.672 19 6.5 19 L 12.5 19 C 13 19.776 12.776 20 12.5 20 L 6.5 20 C 5.119 20 4 18.881 4 17.5 L 4 16.788 C 4 15.807 4.573 14.918 5.465 14.512 L 8.922 12.941 C 7.752 12.026 7 10.601 7 9 C 7 6.239 9.239 4 12 4 C 14.761 4 17 6.239 17 9 C 17 10.593 16.255 12.012 15.095 12.927 C 17.303 14.96 14.043 13.565 14.043 13.565 Z M 12 13 C 14.209 13 16 11.209 16 9 C 16 6.791 14.209 5 12 5 C 9.791 5 8 6.791 8 9 C 8 11.209 9.791 13 12 13 Z",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17.122 19.999 C 19.474 18.94 18.784 19.095 18.161 19.373 L 14.079 17.518 C 13.544 17.274 13.2 16.74 13.2 16.152 L 13.2 15.44 C 13.2 14.612 13.872 13.94 14.7 13.94 L 19.7 13.94 C 20.2 13.164 19.976 12.94 19.7 12.94 L 14.7 12.94 C 13.319 12.94 12.2 14.059 12.2 15.44 L 12.2 16.152 C 12.2 17.133 12.773 18.022 13.665 18.428 L 17.122 19.999 Z",
    style: {
      transformBox: "fill-box",
      transformOrigin: "50% 50%"
    },
    transform: "matrix(-1, 0, 0, -1, -0.000002, -0.000002)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAccount);
export default __webpack_public_path__ + "static/media/user_account.206fc7abc941f842b4ac85db69b829dd.svg";
export { ForwardRef as ReactComponent };